import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RequiredGuard implements CanActivate {

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private sanitizer: DomSanitizer
  ) { }

  canActivate(route: any, state: RouterStateSnapshot): boolean | UrlTree {
    if (!isPlatformBrowser(this.platformId)) {
      return true; // SSR, allow
    }

    let userDetailsJSON: any = null;
    if(typeof window !== "undefined"){
      try {
        const userDetails = localStorage.getItem('USER');
        userDetailsJSON = userDetails ? JSON.parse(userDetails) : null;
      } catch {
        userDetailsJSON = null;
      }
    }

    const isUserLoggedIn = !!userDetailsJSON;

    // 

    const url = route?.['_routerState']?.url || '';
    let isUpdateRequiredPage = ((url || '').toLowerCase()).indexOf("/my-profile-required") !== -1;
    if(isUpdateRequiredPage) {
      if(!isUserLoggedIn || (isUserLoggedIn && userDetailsJSON?.isRegistered) || (isUserLoggedIn && !userDetailsJSON?.isRegistered && !userDetailsJSON?.isRegistrationMandatory)) {
        const redirectUrl = `/${localStorage.getItem('LANGUAGE') || 'en'}/dashboard/my-profile`;
        return this.router.parseUrl(redirectUrl);        
      }
      return true;
    }

    const redirectUrl = `/${localStorage.getItem('LANGUAGE') || 'en'}/dashboard/my-profile-required`;    
    if(!userDetailsJSON?.isUpdate && userDetailsJSON?.isRegistered && userDetailsJSON?.isRegistrationMandatory){
      return this.router.parseUrl(redirectUrl);
    }

    if (!isUserLoggedIn || userDetailsJSON?.isRegistered || (!userDetailsJSON?.isRegistered && !userDetailsJSON?.isRegistrationMandatory)) {
      return true;
    }

    return this.router.parseUrl(redirectUrl);
  }

}